import profile from './profile.JPG'
//import logo from './GDW.png'
import './styles/About.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLinkedin } from '@fortawesome/free-brands-svg-icons'
import { faEnvelopeSquare } from '@fortawesome/free-solid-svg-icons'


export default function About() {
    return (
        <>
        <div className='about-main-container'>
            <div className='about-sub-container'>
                <div className='img-container'>
                    <img src={profile} alt='gordon profile' className='profile-img' height='300px' width='200px'></img>
                </div>
                <article className='about-main-body'>
                    <h2>A little about me...</h2>
                    <p>I'm a developer. My strengths as a programmer lie in logical reasoning, semantic design, and attention to detail. As a music student, I learned the art of approaching complex problems from multiple angles to find the best solution. I also learned that there's never one right answer, and sometimes the beauty is in finding different ways to answer the same question.</p>
                    <p>When I'm not working on web development, you can find me exploring my many (too many, some might say...) hobbies:</p>
                    <ul>
                        <li>Photography</li>
                        <li>Watchmaking and Collecting</li>
                        <li>Chess</li>
                        <li>Hiking</li>
                        <li>Weightlifting</li>
                        <li>...Watching TV...</li>
                    </ul>
                </article>
                <article className='about-sub-body'>
                    <h3>And About The Site</h3>
                    <p>
                        This site was built from the ground up in React. Animations are provided by react-motion and css animations, styles are built using individual component stylesheets (but are currently being migrated...slowly...into styled components), and icons are provided by fontawesome.
                    </p>
                </article>
                <section className='contact-container-small'>
                    <form className='contact-form-small'>
                        <h3 className='contact-header-small'>Contact Me</h3>
                        <section className='contact-links-small'>
                            <address className='email'>
                                <a href='mailto:cgordondw@gmail.com'>
                                    <FontAwesomeIcon icon={faEnvelopeSquare} size='3x' />
                                </a>
                            </address>
                            <a href='https://www.linkedin.com/in/gordon-daole-wellman-0b275566/' target='_blank' rel="noopener noreferrer">
                                <FontAwesomeIcon icon={faLinkedin} size='3x' />
                            </a> 
                        </section>
                    </form>
                </section>
            </div>
        </div>
        <div className='contact-container-large'>
            <form className='contact-form-large'>
                <h3 className='contact-header-large'>Contact Me</h3>
                <section className='contact-links-large'>
                    <address className='email'>
                        <a href='mailto:cgordondw@gmail.com'>
                            <FontAwesomeIcon icon={faEnvelopeSquare} size='3x' />
                        </a>
                    </address>
                    <a href='https://www.linkedin.com/in/gordon-daole-wellman-0b275566/' target='_blank' rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faLinkedin} size='3x' />
                    </a> 
                </section>
            </form>
        </div>
    </>
    )
}